import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, map } from 'rxjs';
import { UserService } from '../services/user.service';
import { AuthenticationService } from '../services/authentication.service';
import { environment } from '../../environments/environment';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';


interface FileContents {
    fileType: string,
    fileName: string,
    fileSize: string,
    fileContentBase64: string,
    url: string
}

export const LANGUAGES = [
    { value: "Assamese", name: "Assamese" },
    { value: "Bengali", name: "Bengali" },
    { value: "Gujarati", name: "Gujarati" },
    { value: "Hindi", name: "Hindi" },
    { value: "Kannada", name: "Kannada" },
    { value: "Malayalam", name: "Malayalam" },
    { value: "Marathi", name: "Marathi" },
    { value: "Oriya", name: "Oriya" },
    { value: "Punjabi", name: "Punjabi" },
    { value: "Tamil", name: "Tamil" },
    { value: "Telugu", name: "Telugu" },

];

@Injectable({
    providedIn: 'root',
})
export class EllmoService {
    private baseUrl: string = environment.baseUrl;
    private baseanotherUrl: string = environment.baseUrlOther;
    userDetails: any;

    constructor(
        private http: HttpClient,
        private authService: AuthenticationService,
        private ngZone: NgZone,
        private authenticationService: AuthenticationService
    ) { }

    simulate404(): Observable<any> {
        console.log("entered 404")
        const url = '/not-found';
        return this.http.get(url).pipe(
            catchError((error: HttpErrorResponse) => {
                const notFoundResponse = new HttpResponse<any>({
                    body: null,
                    status: 404,
                    statusText: 'Not Found',
                });
                if (error.status === 404) {


                    console.log("if case")
                    return throwError(notFoundResponse);
                } else {
                    console.log("else case")
                    return throwError(notFoundResponse);
                }
            })
        );
    }

    startChat(
        userId: string,
        chatId: string,
        question: string,
        history: [],
        retrievalLevel: string,
        fileRetrievalLevel: string,
        outputFormat: string,
        action: string,
        customPrompt: string,
        files: string,
        voice: string,
        token: any,
        selectedModel : string,
        tempfiles:[]
        
    ): Observable<any> {
        const requestBody = {
            userId,
            chatId,
            question,
            history,
            retrievalLevel,
            fileRetrievalLevel,
            outputFormat,
            action,
            customPrompt,
            files,
            voice,
            selectedModel,
            tempfiles
        };
        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post<any>(
            `${this.baseUrl}/api/v2/ellmo/chats`,
            requestBody,
            { headers: headers }
        );
    }

    newPrompt(
        userId: string,
        promptTitle: string,
        promptDesc: string,
        promptData: string,
        token: any
    ): Observable<any> {
        const requestBody = {
            userId,
            promptTitle,
            promptDesc,
            promptData,
        };
        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post(
            `${this.baseUrl}/api/v2/ellmo/prompts`,
            requestBody,
            { headers: headers }
        );
    }

    retrieveChatWithId(userId: string, chatId: string, token: any): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token,
        };

        return this.http.get(
            `${this.baseUrl}/api/v2/ellmo/chats/c?userId=${userId}&chatId=${chatId}`,
            { headers: headers }
        );
    }

    retrieveTopChats(userId: string, pageId: number, token: any): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token,
        };

        return this.http.get(
            `${this.baseUrl}/api/v2/ellmo/chats/h?userId=${userId}&pageId=${pageId}`,
            { headers: headers }
        );
    }

    getPrompts(userId: string, promptId: string, token: any): Observable<any> {
        const data = new FormData();
        data.append('userId', userId);
        data.append('promptId', promptId);

        const headers = {
            Authorization: 'Bearer ' + token,
        };

        return this.http.get(
            `${this.baseUrl}/api/v2/ellmo/prompts/prompt?userId=${userId}&promptId=${promptId}`,
            { headers: headers }
        );
    }

    saveEditedPrompt(
        userId: string,
        promptId: string,
        promptTitle: string,
        promptDesc: string,
        promptData: string,
        token: any
    ): Observable<any> {
        const requestBody = {
            userId,
            promptId,
            promptTitle,
            promptData,
            promptDesc,
        };
        const headers = {
            Authorization: 'Bearer ' + token,
        };

        return this.http.patch<any>(
            `${this.baseUrl}/api/v2/ellmo/prompts`,
            requestBody,
            { headers: headers }
        );
    }

    getUserDetails(email: string, refresh: boolean, token: any): Observable<any> {
        console.log('calling get user details for ' + email);
        const headers = {
            Authorization: 'Bearer ' + token,
        };

        return this.http
            .get(`${this.baseUrl}/api/v2/ellmo/users/user?userId=${email}`, {
                headers: headers,
            })
            .pipe(
                map((response: any) => {
                    this.userDetails = response;
                    return response;
                })
            );
    }

    cmpGet(emailId: string, recipientId: string, mailerId: string, type: string): Observable<any> {
        console.log("Calling mail capturing for email campaign");
        return this.http.get(`https://api.genailia.com/api/v1/misc/track?emailId=${emailId}&recipientId=${recipientId}&mailerId=${mailerId}&type=${type}`)
    }

    deletePrompt(userId: string, promptId: string, token: any): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token,
        };

        return this.http.delete(
            `${this.baseUrl}/api/v2/ellmo/prompts?userId=${userId}&promptId=${promptId}`,
            { headers: headers }
        );
    }

    deleteChat(userId: string, chatId: string, token: any): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token,
        };

        return this.http.delete(
            `${this.baseUrl}/api/v2/ellmo/chats/c?userId=${userId}&chatId=${chatId}`,
            { headers: headers }
        );
    }

    deleteFile(userId: string, fileId: string, fileName: string, token: any): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.delete(
            `${this.baseUrl}/api/v2/ellmo/fileuploads?userId=${userId}&fileId=${fileId}&fileName=${fileName}`,
            { headers: headers }
        );

    }

    editChatName(
        userId: string,
        chatId: string,
        chatTitle: string,
        token: any
    ): Observable<any> {
        const requestBody = {
            userId: userId,
            chatId: chatId,
            chatTitle: chatTitle,
        };

        const headers = {
            Authorization: 'Bearer ' + token,
        };

        return this.http.patch(
            `${this.baseUrl}/api/v2/ellmo/chats`,
            requestBody,
            { headers: headers }
        );
    }

    deleteAllChats(userId: string, flag: string, token: any): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token,
        };

        return this.http.delete(
            `${this.baseUrl}/api/v2/ellmo/chats/c?userId=${userId}&chatId=${flag}`,
            { headers: headers }
        );
    }

    submitAppFeedback(
        userId: string,
        rating: string,
        feedback: string,
        token: any
    ): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token,
        };

        const requestBody = {
            userId: userId,
            rating: rating,
            feedback: feedback,
        };
        return this.http.post(
            `${this.baseUrl}/api/v2/ellmo/userevent/appfeedback`,
            requestBody,
            { headers: headers }
        );
    }

    submitResponseFeedback(
        userId: string,
        rating: string,
        ratingMessage: string,
        chatId: string,
        chatSeqIdResponse: string,
        indicator:boolean,  
        token: any
    ): Observable<any> {
        const requestBody = {
            userId: userId,
            rating: rating,
            ratingMessage: ratingMessage,
            chatId: chatId,
            chatSeqId: chatSeqIdResponse,
            indicator:indicator
        };
        const headers = {
            Authorization: 'Bearer ' + token,
        };
        console.log(requestBody);

        return this.http.post(
            `${this.baseUrl}/api/v2/ellmo/userevent/responsefeedback`,
            requestBody,
            { headers: headers }
        );
    }

    submitUserEvent(userId: string, event: string, token: any): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post(
            `${this.baseUrl}/api/v2/ellmo/userevent?userId=${userId}&event=${event}`,
            null,
            { headers: headers }
        );
    }

    convertBlobToBase64 = (blob: Blob) => {
        return this.ngZone.run(() => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onerror = reject;
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.readAsDataURL(blob);
            });
        });
    };

    uploadFiles(
        userId: string,
        fileUploadLevel: string,
        fileContents: FileContents[],
        integrations: any[],
        token: any
    ): Observable<any> {
        const requestBody = {
            userId,
            fileUploadLevel,
            fileContents,
            integrations
        };
        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.post(
            `${this.baseUrl}/api/v2/ellmo/fileuploads`,
            requestBody,
            { headers: headers }
        );
    }

    getFilesByLevel(userId: string, fileUploadLevel: string, token: any): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.get(
            `${this.baseUrl}/api/v2/ellmo/fileuploads/orgfile?userId=${userId}&fileUploadLevel=${fileUploadLevel}`,
            { headers: headers }
        );
    }

    changeTheme(userId: string, theme: string, operation: string, token: any): Observable<any> {
        
        const requestBody = {
            userId,
            theme,
            operation,
        };
        console.log(userId, theme, operation)
        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.patch<any>(
            `${this.baseUrl}/api/v2/ellmo/users`,
            requestBody,
            { headers: headers }
        );
    }

    shareChat(userId: string, chatId: string, chatTitle: string, token: any): Observable<any> {

        const requestBody = {
            userId,
            chatId,
            chatTitle,
        };
        const headers = {
            Authorization: 'Bearer ' + token
        };
        return this.http.post(
            `${this.baseUrl}/api/v2/ellmo/chats/s`,
            requestBody,
            { headers: headers }
        );
    }

    getShareChat(userId: string, shareId: string, token:any): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token
        };
        return this.http.get(
            `${this.baseUrl}/api/v2/ellmo/chats/s/c?userId=${userId}&shareId=${shareId}`,
            { headers: headers }
        );

    }

    getAllShares(userId: string, token:any): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token
        };
        return this.http.get(
            `${this.baseUrl}/api/v2/ellmo/chats/s?userId=${userId}`,
            { headers: headers }
        );
    }

    deleteEachShare(userId: string, shareId: string, token:any): Observable<any> {

        const headers = {
            Authorization: 'Bearer ' + token
        };
        return this.http.delete(
            `${this.baseUrl}/api/v2/ellmo/chats/s?userId=${userId}&shareId=${shareId}`,
            { headers: headers }
        );

    }

    getChatIdeas(userId: string, chatId: string, token: any): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.get(
            `${this.baseUrl}/api/v2/ellmo/chats/c/topics?userId=${userId}&chatId=${chatId}`,
            { headers: headers }
        );
    }

    getFileContent(userId: string, fileId: string, token: any): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.get(
            `${this.baseUrl}/api/v2/ellmo/fileuploads/file?userId=${userId}&fileId=${fileId}`,
            { headers: headers }
        );
    }

    base64toBlob(base64Data: string, contentType: string) {
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }

    downloadFile(blob: Blob, fileName: string) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    }

    getLanguage() {
        return of(LANGUAGES);
    }

    xlit(text: any, from: string, member: string, token: any): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token,
        };
        return this.http.get(
            `${this.baseUrl}/api/v2/ellmo/chats/transliterate?userId=${member}&word=${text}&sourceLang=${from}`,
            { headers: headers }
        );
    }

    getModels(token:any): Observable<any> {
        const headers = {
            Authorization: 'Bearer ' + token,
        }
        console.log('v2 '+token);
        return this.http.get(
            `${this.baseUrl}/api/v2/ellmoModels`,
            { headers: headers }
        );
    }

    getTheMessagesInExport(messages2:any, format:any,token:any):Observable<any>{
        var messages : any[] = [];
        for(let msg of messages2) {
            messages.push(msg.LLM);
        }
        const requestBody = {
            messages,
            format
        };

        const headers = {
            Authorization: 'Bearer ' + token,
        }
        return this.http.post(
            `${this.baseanotherUrl}/exportChat`,
            requestBody,
            { headers: headers }
        );


    }

}
